export enum CharityType {
  None,
  NearestTotal,
  Preset, // Preset donation amount (e.g., 1, 2, 3)
  Custom, // Custom amount entered by the user
}
